import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';

export interface FetchUserPendingMessagesParams {
	readonly authorsId: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchUserPendingMessagesApiQuery extends ApiQuery<
	{ [key: string]: number },
	FetchUserPendingMessagesParams
> {
	client = 'messaging';
	document = gql`
		query FetchUserPendingMessages($authorsId: [UUID]) {
			fetchUserPendingMessages(authorsId: $authorsId)
		}
	`;
	method = 'fetchUserPendingMessages';
}
